/* eslint-disable */
// Generated by plugins/i18n-types from the base-language locale files
// (<namespace>.en-US.json) found in the locales/ folders under src.
//
// Regenerated on dev (when a locale file is added or removed) and on build.
// npm run validate:i18n fails when this file is stale, since tsc does not go
// through Vite.

import type auth from '@/pages/auth/locales/auth.en-US.json'
import type botMigration from '@/pages/bot-migrations/locales/botMigration.en-US.json'
import type bots from '@/i18n/shared/locales/bots.en-US.json'
import type botTheme from '@/pages/bot-theme/locales/botTheme.en-US.json'
import type bubble from '@/pages/bubble/locales/bubble.en-US.json'
import type campaign from '@/pages/campaign/locales/campaign.en-US.json'
import type campaignModule from '@/pages/campaign-module/locales/campaignModule.en-US.json'
import type common from '@/i18n/locales/common.en-US.json'
import type companies from '@/pages/company/locales/companies.en-US.json'
import type components from '@/i18n/locales/components.en-US.json'
import type conversationHistory from '@/pages/conversation-history/locales/conversationHistory.en-US.json'
import type dashboards from '@/pages/dashboards/locales/dashboards.en-US.json'
import type finn from '@/pages/finn/locales/finn.en-US.json'
import type followUp from '@/pages/follow-up/locales/followUp.en-US.json'
import type integrations from '@/pages/integrations/locales/integrations.en-US.json'
import type knowledgeBase from '@/pages/knowledge-base/locales/knowledgeBase.en-US.json'
import type members from '@/i18n/shared/locales/members.en-US.json'
import type notFound from '@/pages/not-found/locales/notFound.en-US.json'
import type projects from '@/i18n/shared/locales/projects.en-US.json'
import type workspaces from '@/pages/company/locales/workspaces.en-US.json'

export const ALL_NAMESPACES = [
  'auth',
  'botMigration',
  'bots',
  'botTheme',
  'bubble',
  'campaign',
  'campaignModule',
  'common',
  'companies',
  'components',
  'conversationHistory',
  'dashboards',
  'finn',
  'followUp',
  'integrations',
  'knowledgeBase',
  'members',
  'notFound',
  'projects',
  'workspaces',
] as const

export type Resources = {
  auth: typeof auth
  botMigration: typeof botMigration
  bots: typeof bots
  botTheme: typeof botTheme
  bubble: typeof bubble
  campaign: typeof campaign
  campaignModule: typeof campaignModule
  common: typeof common
  companies: typeof companies
  components: typeof components
  conversationHistory: typeof conversationHistory
  dashboards: typeof dashboards
  finn: typeof finn
  followUp: typeof followUp
  integrations: typeof integrations
  knowledgeBase: typeof knowledgeBase
  members: typeof members
  notFound: typeof notFound
  projects: typeof projects
  workspaces: typeof workspaces
}
